import React from "react";
import SecureLS from "secure-ls";
import { Redirect, Route } from "react-router-dom";

export default function RequireAuth({
  component: Component,
  requiredUserType,
  ...rest
}) {
  var ls = new SecureLS();
  let jwttoken = ls.get("key1").jwtToken;
  let userType = ls.get("key1").userType;

  let isAuth = !!jwttoken;
  let hasRequiredUserType = requiredUserType
    ? userType === requiredUserType
    : true;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth && hasRequiredUserType ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: isAuth ? "/dashboard" : "/",
            }}
          />
        )
      }
    />
  );
}
